var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ngTranslate from 'angular-translate';
import { NgModule } from 'angular-ts-decorators';
import { AdminSettingsModule } from '../admin-settings/admin-settings.module';
import { LocaleModule, SUPPORTED_LANGUAGES_INJECTION_TOKEN } from '../locale/locale.module';
import { SharedModule } from '../shared/shared.module';
import { LoginLightComponent } from './login-light/login-light.component';
import { LoginOAuthComponent } from './login-oauth/login-oauth.component';
import { LoginSubmitComponent } from './login-submit/login-submit.component';
import { LoginComponent } from './login/login.component';
import { ExposePasswordDirective } from '../directives/expose-password.directive';
import { de } from './i18n/de';
import { en } from './i18n/en';
import { es } from './i18n/es';
import { fr } from './i18n/fr';
import { it } from './i18n/it';
import { SendOneTimeLoginCodeController } from './send-one-time-login-code/send-one-time-login-code.controller';
import { VerifyOneTimeLoginCodeController } from './verify-one-time-login-code/verify-one-time-login-code.controller';
import { VerifyTwoFactorCodeController } from './verify-two-factor-code/verify-two-factor-code.controller';
let AuthModule = class AuthModule {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$translateProvider', SUPPORTED_LANGUAGES_INJECTION_TOKEN];
    static config($translateProvider, SUPPORTED_LANGUAGES) {
        const LOCALES = { de, en, es, fr, it };
        for (const locale of SUPPORTED_LANGUAGES) {
            const localeData = LOCALES[locale];
            if (localeData) {
                $translateProvider.translations(locale, localeData ?? {});
            }
        }
    }
};
AuthModule = __decorate([
    NgModule({
        id: 'AuthModule',
        imports: [ngTranslate, AdminSettingsModule, LocaleModule, SharedModule],
        declarations: [
            ExposePasswordDirective,
            LoginComponent,
            LoginLightComponent,
            LoginOAuthComponent,
            LoginSubmitComponent,
            SendOneTimeLoginCodeController,
            VerifyTwoFactorCodeController,
            VerifyOneTimeLoginCodeController,
        ],
        bootstrap: [],
    })
], AuthModule);
export { AuthModule };
AuthModule
    .module.controller('SendOneTimeLoginCodeController', SendOneTimeLoginCodeController)
    .controller('VerifyTwoFactorCodeController', VerifyTwoFactorCodeController)
    .controller('VerifyOneTimeLoginCodeController', VerifyOneTimeLoginCodeController);
